"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactPlugin = reactPlugin;
exports.onRumInit = onRumInit;
exports.onRumStart = onRumStart;
exports.resetReactPlugin = resetReactPlugin;
let globalPublicApi;
let globalConfiguration;
let globalStrategy;
const onRumInitSubscribers = [];
const onRumStartSubscribers = [];
function reactPlugin(configuration = {}) {
    return {
        name: 'react',
        onInit({ publicApi, initConfiguration }) {
            globalPublicApi = publicApi;
            globalConfiguration = configuration;
            for (const subscriber of onRumInitSubscribers) {
                subscriber(globalConfiguration, globalPublicApi);
            }
            if (configuration.router) {
                initConfiguration.trackViewsManually = true;
            }
        },
        onRumStart({ strategy }) {
            globalStrategy = strategy;
            for (const subscriber of onRumStartSubscribers) {
                subscriber(strategy);
            }
        },
        getConfigurationTelemetry() {
            return { router: !!configuration.router };
        },
    };
}
function onRumInit(callback) {
    if (globalConfiguration && globalPublicApi) {
        callback(globalConfiguration, globalPublicApi);
    }
    else {
        onRumInitSubscribers.push(callback);
    }
}
function onRumStart(callback) {
    if (globalStrategy) {
        callback(globalStrategy);
    }
    else {
        onRumStartSubscribers.push(callback);
    }
}
function resetReactPlugin() {
    globalPublicApi = undefined;
    globalConfiguration = undefined;
    globalStrategy = undefined;
    onRumInitSubscribers.length = 0;
    onRumStartSubscribers.length = 0;
}
//# sourceMappingURL=reactPlugin.js.map